/**
 * @description Component-RemoveLiqForm
 */
import './index.less';

import { FC, useCallback, useEffect } from 'react';

import { EARN_TYPE } from '@/constants/earn';
import { useWrappedPortfolioByPairId } from '@/features/account/portfolioHook';
import { useCurrentRange } from '@/features/account/rangeHook';
import { removeLiquiditySimulate, resetLiquidityFormByChainId, setEarnFormType } from '@/features/earn/action';
import { useEarnFormType, useRemoveLiquidationSimulation, useRemoveLiquidationSuccess } from '@/features/earn/hook';
import { useGlobalConfig } from '@/features/global/hooks';
import { useSDK } from '@/features/web3/hook';
import { useAppDispatch } from '@/hooks';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import { perToTenThousands } from '@/utils/trade';

import { useMediaQueryDevice } from '@/components/MediaQuery';
import { useTradeStore } from '@/features/trade/store';
import useSetTradePortfolioTab from '@/hooks/trade/useSetTradePortfolioTab';
import EarnFormFooter from '../../EarnFormFooter';
import EarnFormAlert from '../EarnFormAlert';
import RemoveLiqFormDetail from '../RemoveLiqFormDetail';
interface IPropTypes {
  className?: string;
  onClose?: () => void;
}
const RemoveLiqForm: FC<IPropTypes> = function ({ onClose }) {
  const chainId = useChainId();
  // const { dataTheme } = useTheme();
  const { setShowTradeAreaOverlay } = useTradeStore();
  const userAddr = useUserAddr();
  const dispatch = useAppDispatch();
  const range = useCurrentRange(chainId, userAddr);
  const currentPair = range?.rootPair;
  const portfolio = useWrappedPortfolioByPairId(chainId, userAddr, currentPair?.id);
  const sdkContext = useSDK(chainId);
  const { slippage } = useGlobalConfig(chainId);
  const simulation = useRemoveLiquidationSimulation(chainId);
  const removeSuccess = useRemoveLiquidationSuccess(chainId, EARN_TYPE.REMOVE_LIQ);
  const setTradePortfolioTab = useSetTradePortfolioTab();
  const { isMobile } = useMediaQueryDevice();
  const earnType = useEarnFormType(chainId);

  const closeRemove = useCallback(() => {
    if (onClose) {
      onClose();
      return;
    }
  }, [onClose]);
  //const { t } = useTranslation();
  useEffect(() => {
    chainId &&
      range &&
      slippage &&
      portfolio &&
      portfolio.rootPair.id === range.rootPair?.id &&
      dispatch(
        removeLiquiditySimulate({
          chainId,
          sdkContext,
          portfolio,
          range,
          slippage: perToTenThousands(Number(slippage)),
        }),
      );
  }, [chainId, dispatch, portfolio, range, range?.id, sdkContext, slippage]);
  useEffect(() => {
    if (removeSuccess && chainId) {
      dispatch(
        setEarnFormType({
          chainId,
          formType: EARN_TYPE.ADD_LIQ,
        }),
      );
    }
  }, [chainId, dispatch, removeSuccess, setTradePortfolioTab]);
  useEffect(() => {
    // Only check if range is loaded (implied by portfolio existing)
    if (!portfolio?.ranges || portfolio.ranges.size <= 0) {
      setShowTradeAreaOverlay(undefined);
    }
  }, [portfolio?.ranges]);
  useEffect(() => {
    if (portfolio && range && portfolio?.rootPair.id !== range?.rootPair?.id) {
      setShowTradeAreaOverlay(undefined);
    }
  }, [portfolio?.rootPair.id, range?.rootPair?.id]);

  useEffect(() => {
    return () => {
      if (currentPair?.id && chainId) {
        if (earnType === EARN_TYPE.REMOVE_LIQ) {
          return;
        }
        dispatch(resetLiquidityFormByChainId({ chainId }));

        setShowTradeAreaOverlay(undefined);
      }
    };
    // need to reset the form when pair changes
  }, [currentPair?.id]);

  useEffect(() => {
    return () => {
      if (chainId) {
        if (earnType === EARN_TYPE.REMOVE_LIQ) {
          return;
        }
        dispatch(resetLiquidityFormByChainId({ chainId }));

        setShowTradeAreaOverlay(undefined);
      }
    };
  }, []);

  return (
    <div className="syn-remove-liq-form">
      {/* {removeSuccess ? (
        <div className="syn-remove-liq-form-success">
          <img src={dataTheme === THEME_ENUM.LIGHT ? SucccessLogo : SucccessLogo_dark} />
          <div className="syn-remove-liq-form-success-line">{t('common.earn.removeSuccessLine')}</div>
        </div>
      ) : (
        <> */}
      <RemoveLiqFormDetail
        currentPair={currentPair}
        footer={
          <EarnFormFooter
            isMobile={isMobile}
            inputAmountStr={undefined}
            earnType={EARN_TYPE.REMOVE_LIQ}
            onClose={closeRemove}
            currentPair={currentPair}
          />
        }
      />

      <EarnFormAlert
        simulation={simulation}
        chainId={chainId}
        earnType={EARN_TYPE.REMOVE_LIQ}
        marginToken={currentPair?.rootInstrument?.quoteToken}
      />
      {/* </>
      )} */}
    </div>
  );
};

export default RemoveLiqForm;
